export default __webpack_public_path__ + "static/media/img_shouye_houma.9da3bda9.png";